import { DOCUMENT_BLOCK_TYPES, DOCUMENT_ALIGN } from "./schema";

/** Mirrors `templates/proposta_compra_imovel.md` for live preview. */
const propostaCompraImovel = {
  id: "proposta-compra-imovel",

  blocks: [
    {
      type: DOCUMENT_BLOCK_TYPES.TITLE,
      content: "PROPOSTA DE COMPRA DE IMÓVEL",
      align: DOCUMENT_ALIGN.LEFT,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 2 },

    {
      type: DOCUMENT_BLOCK_TYPES.TITLE,
      content: "PROPONENTE(S)",
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{COMPRADORES}",
      contentFormat: "html",
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    {
      type: DOCUMENT_BLOCK_TYPES.TITLE,
      content: "PROPRIETÁRIO(S)",
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{VENDEDORES}",
      contentFormat: "html",
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "As partes acima identificadas firmam a presente PROPOSTA DE COMPRA DE IMÓVEL, que será regida pelas cláusulas e condições a seguir descritas.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 2 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "CLÁUSULAS E CONDIÇÕES",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "1) OBJETO",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "1.1) A presente proposta tem por objeto a intenção de compra do imóvel abaixo descrito:",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "1.1.1) {TIPO_IMOVEL}",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "2) DO VALOR E CONDIÇÕES DA PROPOSTA",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "2.1) O valor total proposto para aquisição do imóvel é de R$ {VALOR_TOTAL} ({VALOR_EXTENSO}).",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "2.2) O pagamento será realizado da seguinte forma:",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "2.2.1) {TIPO_PAGAMENTO}",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "1) PRAZOS",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "1.1) Esta proposta terá validade até a data de {VALIDADE_PROPOSTA}.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "1.2) Após a aceitação, as partes se comprometem a formalizar contrato definitivo no prazo de {PRAZO_CONTRATO} dias.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "2) DA ACEITAÇÃO",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "2.1) A presente proposta terá validade a partir da assinatura do(a) proponente, passando a produzir efeitos obrigacionais somente após a sua aceitação pelo(a) destinatário(a).",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "2.2) O aceite implica concordância integral com todos os termos aqui descritos.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "3) DISPOSIÇÕES GERAIS",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "3.1) As partes declaram que todas as informações prestadas são verdadeiras, assumindo responsabilidade por sua veracidade.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "3.2) Para dirimir quaisquer controvérsias decorrentes desta proposta, as partes elegem o foro da comarca de {FORO}.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 2 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "ENCERRAMENTO",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "POR ESTAREM DE ACORDO,\nassinam a presente proposta.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{CIDADE_ASSINATURA}, {DATA_ASSINATURA}",
      align: DOCUMENT_ALIGN.RIGHT,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 2 },

    {
      type: DOCUMENT_BLOCK_TYPES.TITLE,
      content: "PROPONENTE (COMPRADOR(ES))",
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{ASSINATURA_COMPRADORES}",
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{ASSINATURA_CONJUGE_COMPRADORES}",
      contentFormat: "html",
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    {
      type: DOCUMENT_BLOCK_TYPES.TITLE,
      content: "PROPRIETÁRIO (VENDEDOR(ES))",
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{ASSINATURA_VENDEDORES}",
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{ASSINATURA_CONJUGE_VENDEDORES}",
      contentFormat: "html",
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    { type: DOCUMENT_BLOCK_TYPES.TITLE, content: "TESTEMUNHAS" },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{ASSINATURA_TESTEMUNHAS}",
    },
  ],
};

export default propostaCompraImovel;
